const datasets = (() => {
    return {
    countries: [
      { label: 'Afghanistan', value: 'AF' },
      { label: 'Åland Islands', value: 'AX' },
      { label: 'Albania', value: 'AL' },
      { label: 'Algeria', value: 'DZ' },
      { label: 'American Samoa', value: 'AS' },
      { label: 'AndorrA', value: 'AD' },
      { label: 'Angola', value: 'AO' },
      { label: 'Anguilla', value: 'AI' },
      { label: 'Antarctica', value: 'AQ' },
      { label: 'Antigua and Barbuda', value: 'AG' },
      { label: 'Argentina', value: 'AR' },
      { label: 'Armenia', value: 'AM' },
      { label: 'Aruba', value: 'AW' },
      { label: 'Australia', value: 'AU' },
      { label: 'Austria', value: 'AT' },
      { label: 'Azerbaijan', value: 'AZ' },
      { label: 'Bahamas', value: 'BS' },
      { label: 'Bahrain', value: 'BH' },
      { label: 'Bangladesh', value: 'BD' },
      { label: 'Barbados', value: 'BB' },
      { label: 'Belarus', value: 'BY' },
      { label: 'Belgium', value: 'BE' },
      { label: 'Belize', value: 'BZ' },
      { label: 'Benin', value: 'BJ' },
      { label: 'Bermuda', value: 'BM' },
      { label: 'Bhutan', value: 'BT' },
      { label: 'Bolivia', value: 'BO' },
      { label: 'Bosnia and Herzegovina', value: 'BA' },
      { label: 'Botswana', value: 'BW' },
      { label: 'Bouvet Island', value: 'BV' },
      { label: 'Brazil', value: 'BR' },
      { label: 'British Indian Ocean Territory', value: 'IO' },
      { label: 'Brunei Darussalam', value: 'BN' },
      { label: 'Bulgaria', value: 'BG' },
      { label: 'Burkina Faso', value: 'BF' },
      { label: 'Burundi', value: 'BI' },
      { label: 'Cambodia', value: 'KH' },
      { label: 'Cameroon', value: 'CM' },
      { label: 'Canada', value: 'CA' },
      { label: 'Cape Verde', value: 'CV' },
      { label: 'Cayman Islands', value: 'KY' },
      { label: 'Central African Republic', value: 'CF' },
      { label: 'Chad', value: 'TD' },
      { label: 'Chile', value: 'CL' },
      { label: 'China', value: 'CN' },
      { label: 'Christmas Island', value: 'CX' },
      { label: 'Cocos (Keeling) Islands', value: 'CC' },
      { label: 'Colombia', value: 'CO' },
      { label: 'Comoros', value: 'KM' },
      { label: 'Congo', value: 'CG' },
      { label: 'Congo, The Democratic Republic of the', value: 'CD' },
      { label: 'Cook Islands', value: 'CK' },
      { label: 'Costa Rica', value: 'CR' },
      { label: 'Cote D\'Ivoire', value: 'CI' },
      { label: 'Croatia', value: 'HR' },
      { label: 'Cuba', value: 'CU' },
      { label: 'Cyprus', value: 'CY' },
      { label: 'Czech Republic', value: 'CZ' },
      { label: 'Denmark', value: 'DK' },
      { label: 'Djibouti', value: 'DJ' },
      { label: 'Dominica', value: 'DM' },
      { label: 'Dominican Republic', value: 'DO' },
      { label: 'Ecuador', value: 'EC' },
      { label: 'Egypt', value: 'EG' },
      { label: 'El Salvador', value: 'SV' },
      { label: 'Equatorial Guinea', value: 'GQ' },
      { label: 'Eritrea', value: 'ER' },
      { label: 'Estonia', value: 'EE' },
      { label: 'Ethiopia', value: 'ET' },
      { label: 'Falkland Islands (Malvinas)', value: 'FK' },
      { label: 'Faroe Islands', value: 'FO' },
      { label: 'Fiji', value: 'FJ' },
      { label: 'Finland', value: 'FI' },
      { label: 'France', value: 'FR' },
      { label: 'French Guiana', value: 'GF' },
      { label: 'French Polynesia', value: 'PF' },
      { label: 'French Southern Territories', value: 'TF' },
      { label: 'Gabon', value: 'GA' },
      { label: 'Gambia', value: 'GM' },
      { label: 'Georgia', value: 'GE' },
      { label: 'Germany', value: 'DE' },
      { label: 'Ghana', value: 'GH' },
      { label: 'Gibraltar', value: 'GI' },
      { label: 'Greece', value: 'GR' },
      { label: 'Greenland', value: 'GL' },
      { label: 'Grenada', value: 'GD' },
      { label: 'Guadeloupe', value: 'GP' },
      { label: 'Guam', value: 'GU' },
      { label: 'Guatemala', value: 'GT' },
      { label: 'Guernsey', value: 'GG' },
      { label: 'Guinea', value: 'GN' },
      { label: 'Guinea-Bissau', value: 'GW' },
      { label: 'Guyana', value: 'GY' },
      { label: 'Haiti', value: 'HT' },
      { label: 'Heard Island and Mcdonald Islands', value: 'HM' },
      { label: 'Holy See (Vatican City State)', value: 'VA' },
      { label: 'Honduras', value: 'HN' },
      { label: 'Hong Kong', value: 'HK' },
      { label: 'Hungary', value: 'HU' },
      { label: 'Iceland', value: 'IS' },
      { label: 'India', value: 'IN' },
      { label: 'Indonesia', value: 'ID' },
      { label: 'Iran, Islamic Republic Of', value: 'IR' },
      { label: 'Iraq', value: 'IQ' },
      { label: 'Ireland', value: 'IE' },
      { label: 'Isle of Man', value: 'IM' },
      { label: 'Israel', value: 'IL' },
      { label: 'Italy', value: 'IT' },
      { label: 'Jamaica', value: 'JM' },
      { label: 'Japan', value: 'JP' },
      { label: 'Jersey', value: 'JE' },
      { label: 'Jordan', value: 'JO' },
      { label: 'Kazakhstan', value: 'KZ' },
      { label: 'Kenya', value: 'KE' },
      { label: 'Kiribati', value: 'KI' },
      { label: 'Korea, Democratic People\'S Republic of', value: 'KP' },
      { label: 'Korea, Republic of', value: 'KR' },
      { label: 'Kuwait', value: 'KW' },
      { label: 'Kyrgyzstan', value: 'KG' },
      { label: 'Lao People\'S Democratic Republic', value: 'LA' },
      { label: 'Latvia', value: 'LV' },
      { label: 'Lebanon', value: 'LB' },
      { label: 'Lesotho', value: 'LS' },
      { label: 'Liberia', value: 'LR' },
      { label: 'Libyan Arab Jamahiriya', value: 'LY' },
      { label: 'Liechtenstein', value: 'LI' },
      { label: 'Lithuania', value: 'LT' },
      { label: 'Luxembourg', value: 'LU' },
      { label: 'Macao', value: 'MO' },
      { label: 'Macedonia, The Former Yugoslav Republic of', value: 'MK' },
      { label: 'Madagascar', value: 'MG' },
      { label: 'Malawi', value: 'MW' },
      { label: 'Malaysia', value: 'MY' },
      { label: 'Maldives', value: 'MV' },
      { label: 'Mali', value: 'ML' },
      { label: 'Malta', value: 'MT' },
      { label: 'Marshall Islands', value: 'MH' },
      { label: 'Martinique', value: 'MQ' },
      { label: 'Mauritania', value: 'MR' },
      { label: 'Mauritius', value: 'MU' },
      { label: 'Mayotte', value: 'YT' },
      { label: 'Mexico', value: 'MX' },
      { label: 'Micronesia, Federated States of', value: 'FM' },
      { label: 'Moldova, Republic of', value: 'MD' },
      { label: 'Monaco', value: 'MC' },
      { label: 'Mongolia', value: 'MN' },
      { label: 'Montserrat', value: 'MS' },
      { label: 'Morocco', value: 'MA' },
      { label: 'Mozambique', value: 'MZ' },
      { label: 'Myanmar', value: 'MM' },
      { label: 'Namibia', value: 'NA' },
      { label: 'Nauru', value: 'NR' },
      { label: 'Nepal', value: 'NP' },
      { label: 'Netherlands', value: 'NL' },
      { label: 'Netherlands Antilles', value: 'AN' },
      { label: 'New Caledonia', value: 'NC' },
      { label: 'New Zealand', value: 'NZ' },
      { label: 'Nicaragua', value: 'NI' },
      { label: 'Niger', value: 'NE' },
      { label: 'Nigeria', value: 'NG' },
      { label: 'Niue', value: 'NU' },
      { label: 'Norfolk Island', value: 'NF' },
      { label: 'Northern Mariana Islands', value: 'MP' },
      { label: 'Norway', value: 'NO' },
      { label: 'Oman', value: 'OM' },
      { label: 'Pakistan', value: 'PK' },
      { label: 'Palau', value: 'PW' },
      { label: 'Palestinian Territory, Occupied', value: 'PS' },
      { label: 'Panama', value: 'PA' },
      { label: 'Papua New Guinea', value: 'PG' },
      { label: 'Paraguay', value: 'PY' },
      { label: 'Peru', value: 'PE' },
      { label: 'Philippines', value: 'PH' },
      { label: 'Pitcairn', value: 'PN' },
      { label: 'Poland', value: 'PL' },
      { label: 'Portugal', value: 'PT' },
      { label: 'Puerto Rico', value: 'PR' },
      { label: 'Qatar', value: 'QA' },
      { label: 'Reunion', value: 'RE' },
      { label: 'Romania', value: 'RO' },
      { label: 'Russian Federation', value: 'RU' },
      { label: 'RWANDA', value: 'RW' },
      { label: 'Saint Helena', value: 'SH' },
      { label: 'Saint Kitts and Nevis', value: 'KN' },
      { label: 'Saint Lucia', value: 'LC' },
      { label: 'Saint Pierre and Miquelon', value: 'PM' },
      { label: 'Saint Vincent and the Grenadines', value: 'VC' },
      { label: 'Samoa', value: 'WS' },
      { label: 'San Marino', value: 'SM' },
      { label: 'Sao Tome and Principe', value: 'ST' },
      { label: 'Saudi Arabia', value: 'SA' },
      { label: 'Senegal', value: 'SN' },
      { label: 'Serbia and Montenegro', value: 'CS' },
      { label: 'Seychelles', value: 'SC' },
      { label: 'Sierra Leone', value: 'SL' },
      { label: 'Singapore', value: 'SG' },
      { label: 'Slovakia', value: 'SK' },
      { label: 'Slovenia', value: 'SI' },
      { label: 'Solomon Islands', value: 'SB' },
      { label: 'Somalia', value: 'SO' },
      { label: 'South Africa', value: 'ZA' },
      { label: 'South Georgia and the South Sandwich Islands', value: 'GS' },
      { label: 'Spain', value: 'ES' },
      { label: 'Sri Lanka', value: 'LK' },
      { label: 'Sudan', value: 'SD' },
      { label: 'Suriname', value: 'SR' },
      { label: 'Svalbard and Jan Mayen', value: 'SJ' },
      { label: 'Swaziland', value: 'SZ' },
      { label: 'Sweden', value: 'SE' },
      { label: 'Switzerland', value: 'CH' },
      { label: 'Syrian Arab Republic', value: 'SY' },
      { label: 'Taiwan, Province of China', value: 'TW' },
      { label: 'Tajikistan', value: 'TJ' },
      { label: 'Tanzania, United Republic of', value: 'TZ' },
      { label: 'Thailand', value: 'TH' },
      { label: 'Timor-Leste', value: 'TL' },
      { label: 'Togo', value: 'TG' },
      { label: 'Tokelau', value: 'TK' },
      { label: 'Tonga', value: 'TO' },
      { label: 'Trinidad and Tobago', value: 'TT' },
      { label: 'Tunisia', value: 'TN' },
      { label: 'Turkey', value: 'TR' },
      { label: 'Turkmenistan', value: 'TM' },
      { label: 'Turks and Caicos Islands', value: 'TC' },
      { label: 'Tuvalu', value: 'TV' },
      { label: 'Uganda', value: 'UG' },
      { label: 'Ukraine', value: 'UA' },
      { label: 'United Arab Emirates', value: 'AE' },
      { label: 'United Kingdom', value: 'GB' },
      { label: 'United States', value: 'US' },
      { label: 'United States Minor Outlying Islands', value: 'UM' },
      { label: 'Uruguay', value: 'UY' },
      { label: 'Uzbekistan', value: 'UZ' },
      { label: 'Vanuatu', value: 'VU' },
      { label: 'Venezuela', value: 'VE' },
      { label: 'Viet Nam', value: 'VN' },
      { label: 'Virgin Islands, British', value: 'VG' },
      { label: 'Virgin Islands, U.S.', value: 'VI' },
      { label: 'Wallis and Futuna', value: 'WF' },
      { label: 'Western Sahara', value: 'EH' },
      { label: 'Yemen', value: 'YE' },
      { label: 'Zambia', value: 'ZM' },
      { label: 'Zimbabwe', value: 'ZW' },
    ],
    /* eslint-disable */
    countriesIso: [
      { id: 4, label: 'Afghanistan', alpha2: 'af', value: 'afg' },
      { id: 8, label: 'Albania', alpha2: 'al', value: 'alb' },
      { id: 12, label: 'Algeria', alpha2: 'dz', value: 'dza' },
      { id: 20, label: 'Andorra', alpha2: 'ad', value: 'and' },
      { id: 24, label: 'Angola', alpha2: 'ao', value: 'ago' },
      { id: 28, label: 'Antigua and Barbuda', alpha2: 'ag', value: 'atg' },
      { id: 32, label: 'Argentina', alpha2: 'ar', value: 'arg' },
      { id: 51, label: 'Armenia', alpha2: 'am', value: 'arm' },
      { id: 36, label: 'Australia', alpha2: 'au', value: 'aus' },
      { id: 40, label: 'Austria', alpha2: 'at', value: 'aut' },
      { id: 31, label: 'Azerbaijan', alpha2: 'az', value: 'aze' },
      { id: 44, label: 'Bahamas', alpha2: 'bs', value: 'bhs' },
      { id: 48, label: 'Bahrain', alpha2: 'bh', value: 'bhr' },
      { id: 50, label: 'Bangladesh', alpha2: 'bd', value: 'bgd' },
      { id: 52, label: 'Barbados', alpha2: 'bb', value: 'brb' },
      { id: 112, label: 'Belarus', alpha2: 'by', value: 'blr' },
      { id: 56, label: 'Belgium', alpha2: 'be', value: 'bel' },
      { id: 84, label: 'Belize', alpha2: 'bz', value: 'blz' },
      { id: 204, label: 'Benin', alpha2: 'bj', value: 'ben' },
      { id: 64, label: 'Bhutan', alpha2: 'bt', value: 'btn' },
      { id: 68, label: 'Bolivia (Plurinational State of)', alpha2: 'bo', value: 'bol' },
      { id: 70, label: 'Bosnia and Herzegovina', alpha2: 'ba', value: 'bih' },
      { id: 72, label: 'Botswana', alpha2: 'bw', value: 'bwa' },
      { id: 76, label: 'Brazil', alpha2: 'br', value: 'bra' },
      { id: 96, label: 'Brunei Darussalam', alpha2: 'bn', value: 'brn' },
      { id: 100, label: 'Bulgaria', alpha2: 'bg', value: 'bgr' },
      { id: 854, label: 'Burkina Faso', alpha2: 'bf', value: 'bfa' },
      { id: 108, label: 'Burundi', alpha2: 'bi', value: 'bdi' },
      { id: 132, label: 'Cabo Verde', alpha2: 'cv', value: 'cpv' },
      { id: 116, label: 'Cambodia', alpha2: 'kh', value: 'khm' },
      { id: 120, label: 'Cameroon', alpha2: 'cm', value: 'cmr' },
      { id: 124, label: 'Canada', alpha2: 'ca', value: 'can' },
      { id: 140, label: 'Central African Republic', alpha2: 'cf', value: 'caf' },
      { id: 148, label: 'Chad', alpha2: 'td', value: 'tcd' },
      { id: 152, label: 'Chile', alpha2: 'cl', value: 'chl' },
      { id: 156, label: 'China', alpha2: 'cn', value: 'chn' },
      { id: 170, label: 'Colombia', alpha2: 'co', value: 'col' },
      { id: 174, label: 'Comoros', alpha2: 'km', value: 'com' },
      { id: 178, label: 'Congo', alpha2: 'cg', value: 'cog' },
      { id: 180, label: 'Congo, Democratic Republic of the', alpha2: 'cd', value: 'cod' },
      { id: 188, label: 'Costa Rica', alpha2: 'cr', value: 'cri' },
      { id: 384, label: 'Cote D\'Ivoire', alpha2: 'ci', value: 'civ' },
      { id: 191, label: 'Croatia', alpha2: 'hr', value: 'hrv' },
      { id: 192, label: 'Cuba', alpha2: 'cu', value: 'cub' },
      { id: 196, label: 'Cyprus', alpha2: 'cy', value: 'cyp' },
      { id: 203, label: 'Czechia', alpha2: 'cz', value: 'cze' },
      { id: 208, label: 'Denmark', alpha2: 'dk', value: 'dnk' },
      { id: 262, label: 'Djibouti', alpha2: 'dj', value: 'dji' },
      { id: 212, label: 'Dominica', alpha2: 'dm', value: 'dma' },
      { id: 214, label: 'Dominican Republic', alpha2: 'do', value: 'dom' },
      { id: 218, label: 'Ecuador', alpha2: 'ec', value: 'ecu' },
      { id: 818, label: 'Egypt', alpha2: 'eg', value: 'egy' },
      { id: 222, label: 'El Salvador', alpha2: 'sv', value: 'slv' },
      { id: 226, label: 'Equatorial Guinea', alpha2: 'gq', value: 'gnq' },
      { id: 232, label: 'Eritrea', alpha2: 'er', value: 'eri' },
      { id: 233, label: 'Estonia', alpha2: 'ee', value: 'est' },
      { id: 748, label: 'Eswatini', alpha2: 'sz', value: 'swz' },
      { id: 231, label: 'Ethiopia', alpha2: 'et', value: 'eth' },
      { id: 242, label: 'Fiji', alpha2: 'fj', value: 'fji' },
      { id: 246, label: 'Finland', alpha2: 'fi', value: 'fin' },
      { id: 250, label: 'France', alpha2: 'fr', value: 'fra' },
      { id: 266, label: 'Gabon', alpha2: 'ga', value: 'gab' },
      { id: 270, label: 'Gambia', alpha2: 'gm', value: 'gmb' },
      { id: 268, label: 'Georgia', alpha2: 'ge', value: 'geo' },
      { id: 276, label: 'Germany', alpha2: 'de', value: 'deu' },
      { id: 288, label: 'Ghana', alpha2: 'gh', value: 'gha' },
      { id: 300, label: 'Greece', alpha2: 'gr', value: 'grc' },
      { id: 308, label: 'Grenada', alpha2: 'gd', value: 'grd' },
      { id: 320, label: 'Guatemala', alpha2: 'gt', value: 'gtm' },
      { id: 324, label: 'Guinea', alpha2: 'gn', value: 'gin' },
      { id: 624, label: 'Guinea-Bissau', alpha2: 'gw', value: 'gnb' },
      { id: 328, label: 'Guyana', alpha2: 'gy', value: 'guy' },
      { id: 332, label: 'Haiti', alpha2: 'ht', value: 'hti' },
      { id: 340, label: 'Honduras', alpha2: 'hn', value: 'hnd' },
      { id: 348, label: 'Hungary', alpha2: 'hu', value: 'hun' },
      { id: 352, label: 'Iceland', alpha2: 'is', value: 'isl' },
      { id: 356, label: 'India', alpha2: 'in', value: 'ind' },
      { id: 360, label: 'Indonesia', alpha2: 'id', value: 'idn' },
      { id: 364, label: 'Iran (Islamic Republic of)', alpha2: 'ir', value: 'irn' },
      { id: 368, label: 'Iraq', alpha2: 'iq', value: 'irq' },
      { id: 372, label: 'Ireland', alpha2: 'ie', value: 'irl' },
      { id: 376, label: 'Israel', alpha2: 'il', value: 'isr' },
      { id: 380, label: 'Italy', alpha2: 'it', value: 'ita' },
      { id: 388, label: 'Jamaica', alpha2: 'jm', value: 'jam' },
      { id: 392, label: 'Japan', alpha2: 'jp', value: 'jpn' },
      { id: 400, label: 'Jordan', alpha2: 'jo', value: 'jor' },
      { id: 398, label: 'Kazakhstan', alpha2: 'kz', value: 'kaz' },
      { id: 404, label: 'Kenya', alpha2: 'ke', value: 'ken' },
      { id: 296, label: 'Kiribati', alpha2: 'ki', value: 'kir' },
      { id: 408, label: 'Korea (Democratic People\'s Republic of)', alpha2: 'kp', value: 'prk' },
      { id: 410, label: 'Korea, Republic of', alpha2: 'kr', value: 'kor' },
      { id: 414, label: 'Kuwait', alpha2: 'kw', value: 'kwt' },
      { id: 417, label: 'Kyrgyzstan', alpha2: 'kg', value: 'kgz' },
      { id: 418, label: 'Lao People\'s Democratic Republic', alpha2: 'la', value: 'lao' },
      { id: 428, label: 'Latvia', alpha2: 'lv', value: 'lva' },
      { id: 422, label: 'Lebanon', alpha2: 'lb', value: 'lbn' },
      { id: 426, label: 'Lesotho', alpha2: 'ls', value: 'lso' },
      { id: 430, label: 'Liberia', alpha2: 'lr', value: 'lbr' },
      { id: 434, label: 'Libya', alpha2: 'ly', value: 'lby' },
      { id: 438, label: 'Liechtenstein', alpha2: 'li', value: 'lie' },
      { id: 440, label: 'Lithuania', alpha2: 'lt', value: 'ltu' },
      { id: 442, label: 'Luxembourg', alpha2: 'lu', value: 'lux' },
      { id: 807, label: 'Macedonia, the former Yugoslav Republic of', alpha2: 'mk', value: 'mkd' },
      { id: 450, label: 'Madagascar', alpha2: 'mg', value: 'mdg' },
      { id: 454, label: 'Malawi', alpha2: 'mw', value: 'mwi' },
      { id: 458, label: 'Malaysia', alpha2: 'my', value: 'mys' },
      { id: 462, label: 'Maldives', alpha2: 'mv', value: 'mdv' },
      { id: 466, label: 'Mali', alpha2: 'ml', value: 'mli' },
      { id: 470, label: 'Malta', alpha2: 'mt', value: 'mlt' },
      { id: 584, label: 'Marshall Islands', alpha2: 'mh', value: 'mhl' },
      { id: 478, label: 'Mauritania', alpha2: 'mr', value: 'mrt' },
      { id: 480, label: 'Mauritius', alpha2: 'mu', value: 'mus' },
      { id: 484, label: 'Mexico', alpha2: 'mx', value: 'mex' },
      { id: 583, label: 'Micronesia (Federated States of)', alpha2: 'fm', value: 'fsm' },
      { id: 498, label: 'Moldova, Republic of', alpha2: 'md', value: 'mda' },
      { id: 492, label: 'Monaco', alpha2: 'mc', value: 'mco' },
      { id: 496, label: 'Mongolia', alpha2: 'mn', value: 'mng' },
      { id: 499, label: 'Montenegro', alpha2: 'me', value: 'mne' },
      { id: 504, label: 'Morocco', alpha2: 'ma', value: 'mar' },
      { id: 508, label: 'Mozambique', alpha2: 'mz', value: 'moz' },
      { id: 104, label: 'Myanmar', alpha2: 'mm', value: 'mmr' },
      { id: 516, label: 'Namibia', alpha2: 'na', value: 'nam' },
      { id: 520, label: 'Nauru', alpha2: 'nr', value: 'nru' },
      { id: 524, label: 'Nepal', alpha2: 'np', value: 'npl' },
      { id: 528, label: 'Netherlands', alpha2: 'nl', value: 'nld' },
      { id: 554, label: 'New Zealand', alpha2: 'nz', value: 'nzl' },
      { id: 558, label: 'Nicaragua', alpha2: 'ni', value: 'nic' },
      { id: 562, label: 'Niger', alpha2: 'ne', value: 'ner' },
      { id: 566, label: 'Nigeria', alpha2: 'ng', value: 'nga' },
      { id: 578, label: 'Norway', alpha2: 'no', value: 'nor' },
      { id: 512, label: 'Oman', alpha2: 'om', value: 'omn' },
      { id: 586, label: 'Pakistan', alpha2: 'pk', value: 'pak' },
      { id: 585, label: 'Palau', alpha2: 'pw', value: 'plw' },
      { id: 591, label: 'Panama', alpha2: 'pa', value: 'pan' },
      { id: 598, label: 'Papua New Guinea', alpha2: 'pg', value: 'png' },
      { id: 600, label: 'Paraguay', alpha2: 'py', value: 'pry' },
      { id: 604, label: 'Peru', alpha2: 'pe', value: 'per' },
      { id: 608, label: 'Philippines', alpha2: 'ph', value: 'phl' },
      { id: 616, label: 'Poland', alpha2: 'pl', value: 'pol' },
      { id: 620, label: 'Portugal', alpha2: 'pt', value: 'prt' },
      { id: 634, label: 'Qatar', alpha2: 'qa', value: 'qat' },
      { id: 642, label: 'Romania', alpha2: 'ro', value: 'rou' },
      { id: 643, label: 'Russian Federation', alpha2: 'ru', value: 'rus' },
      { id: 646, label: 'Rwanda', alpha2: 'rw', value: 'rwa' },
      { id: 659, label: 'Saint Kitts and Nevis', alpha2: 'kn', value: 'kna' },
      { id: 662, label: 'Saint Lucia', alpha2: 'lc', value: 'lca' },
      { id: 670, label: 'Saint Vincent and the Grenadines', alpha2: 'vc', value: 'vct' },
      { id: 882, label: 'Samoa', alpha2: 'ws', value: 'wsm' },
      { id: 674, label: 'San Marino', alpha2: 'sm', value: 'smr' },
      { id: 678, label: 'Sao Tome and Principe', alpha2: 'st', value: 'stp' },
      { id: 682, label: 'Saudi Arabia', alpha2: 'sa', value: 'sau' },
      { id: 686, label: 'Senegal', alpha2: 'sn', value: 'sen' },
      { id: 688, label: 'Serbia', alpha2: 'rs', value: 'srb' },
      { id: 690, label: 'Seychelles', alpha2: 'sc', value: 'syc' },
      { id: 694, label: 'Sierra Leone', alpha2: 'sl', value: 'sle' },
      { id: 702, label: 'Singapore', alpha2: 'sg', value: 'sgp' },
      { id: 703, label: 'Slovakia', alpha2: 'sk', value: 'svk' },
      { id: 705, label: 'Slovenia', alpha2: 'si', value: 'svn' },
      { id: 90, label: 'Solomon Islands', alpha2: 'sb', value: 'slb' },
      { id: 706, label: 'Somalia', alpha2: 'so', value: 'som' },
      { id: 710, label: 'South Africa', alpha2: 'za', value: 'zaf' },
      { id: 728, label: 'South Sudan', alpha2: 'ss', value: 'ssd' },
      { id: 724, label: 'Spain', alpha2: 'es', value: 'esp' },
      { id: 144, label: 'Sri Lanka', alpha2: 'lk', value: 'lka' },
      { id: 729, label: 'Sudan', alpha2: 'sd', value: 'sdn' },
      { id: 740, label: 'Suriname', alpha2: 'sr', value: 'sur' },
      { id: 752, label: 'Sweden', alpha2: 'se', value: 'swe' },
      { id: 756, label: 'Switzerland', alpha2: 'ch', value: 'che' },
      { id: 760, label: 'Syrian Arab Republic', alpha2: 'sy', value: 'syr' },
      { id: 762, label: 'Tajikistan', alpha2: 'tj', value: 'tjk' },
      { id: 834, label: 'Tanzania, United Republic of', alpha2: 'tz', value: 'tza' },
      { id: 764, label: 'Thailand', alpha2: 'th', value: 'tha' },
      { id: 626, label: 'Timor-Leste', alpha2: 'tl', value: 'tls' },
      { id: 768, label: 'Togo', alpha2: 'tg', value: 'tgo' },
      { id: 776, label: 'Tonga', alpha2: 'to', value: 'ton' },
      { id: 780, label: 'Trinidad and Tobago', alpha2: 'tt', value: 'tto' },
      { id: 788, label: 'Tunisia', alpha2: 'tn', value: 'tun' },
      { id: 792, label: 'Turkey', alpha2: 'tr', value: 'tur' },
      { id: 795, label: 'Turkmenistan', alpha2: 'tm', value: 'tkm' },
      { id: 798, label: 'Tuvalu', alpha2: 'tv', value: 'tuv' },
      { id: 800, label: 'Uganda', alpha2: 'ug', value: 'uga' },
      { id: 804, label: 'Ukraine', alpha2: 'ua', value: 'ukr' },
      { id: 784, label: 'United Arab Emirates', alpha2: 'ae', value: 'are' },
      { id: 826, label: 'United Kingdom of Great Britain and Northern Ireland', alpha2: 'gb', value: 'gbr' },
      { id: 840, label: 'United States of America', alpha2: 'us', value: 'usa' },
      { id: 858, label: 'Uruguay', alpha2: 'uy', value: 'ury' },
      { id: 860, label: 'Uzbekistan', alpha2: 'uz', value: 'uzb' },
      { id: 548, label: 'Vanuatu', alpha2: 'vu', value: 'vut' },
      { id: 862, label: 'Venezuela (Bolivarian Republic of)', alpha2: 've', value: 'ven' },
      { id: 704, label: 'Viet Nam', alpha2: 'vn', value: 'vnm' },
      { id: 887, label: 'Yemen', alpha2: 'ye', value: 'yem' },
      { id: 894, label: 'Zambia', alpha2: 'zm', value: 'zmb' },
      { id: 716, label: 'Zimbabwe', alpha2: 'zw', value: 'zwe' },
      /* eslint-enable */
    ],
}
})();

  export default datasets;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/utils/datasets.js
 **/